import script from "./ContactInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactInformation.vue?vue&type=script&setup=true&lang=ts"

import "./ContactInformation.vue?vue&type=style&index=0&id=04711a70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04711a70"]])

export default __exports__